<template>
  <div
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
    class="relative flex justify-between items-center menu-container"
    >
    <!-- 使用 router-link 实现点击跳转 -->
    <router-link
      :to="path"
      :class="[
        'nav-text cursor-pointer font-harmony font-medium text-[0.9vw] leading-[1.1458vw] hover:text-primary',
        isActive
          ? 'text-primary active' // 添加激活状态判断
          : !$parent.shouldAlwaysWhite
          ? $parent.isScrolled
            ? 'text-[#676B73]'
            : 'text-white'
          : 'text-[#676B73]',
      ]"
      @click.native="handleSameRouteClick"
    >
      {{ label }}
    </router-link>

    <!-- 下拉菜单容器 -->
     <transition name="slide-up">
      <div
        v-show="items.length > 0 && isHovered"
        class="dropdown-menu absolute left-1/2 top-full transform -translate-x-1/2 mt-[0.4vw] w-[7.2vw] bg-white rounded-lg shadow-lg py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        style="will-change: transform, opacity;text-align: center"
      >
        <a
          v-for="(item, index) in items"
          :key="index"
          href="#"
          class="block px-[0.8vw] py-2 font-harmony font-light text-[0.83vw] text-gray-submenu hover:bg-gray-50 hover:text-primary transition-colors"
          @click.prevent="toPosition(index)"
        >
          {{ item }}
        </a>
      </div>
    </transition>
  </div>
</template>

<script>
import {EventBus} from "@/utils/bus";

export default {
  name: "HeaderItem",
  props: {
    label: String,
    items: Array,
    path: {
      // 新增路由路径 prop
      type: String,
      default: "/",
    },
      elementRef:Array,
      busMethod:String
  },
  computed: {
    isActive() {
      // 使用全等匹配当前路由路径判断激活状态
      return this.$route.path === this.path;
    },
    pathWithTimestamp() {
      // 添加时间戳参数保证路由更新
      return {
        path: this.path,
        query: { t: Date.now() },
      };
    },
  },
  data() {
    return {
      isHovered: false, // 控制整体悬停
      isHover: this.items.map(() => false), // 控制每个子菜单项的悬停（如有需要可扩展）
    };
  },
  methods: {
    handleSameRouteClick() {
      // 相同路径时强制滚动
      if (this.isActive) {
        window.scrollTo(0, 0);
      }
    },
      toPosition(s){
          if (this.path === '/News') {
              const targetCategory = this.elementRef[s];
              const currentQuery = this.$route.query.category;

              // 如果当前已经在目标路径且 category 相同，直接返回
              if (this.$route.path === this.path && currentQuery === targetCategory) {
                  return;
              }

              // 否则跳转带 category 参数
              const url = `${this.path}?category=${targetCategory}`;
              this.$router.push(url);
              return;
          }
        // if(!this.$route.path.startsWith(this.path)){
        //   this.$router.push(this.path)
        // }
        //   console.log(this.busMethod)
        //   console.log(this.elementRef[s])
        // EventBus.$emit(this.busMethod,this.elementRef[s])

          // 构建完整导航路径
          const targetPath = this.path + `?section=${this.elementRef[s]}`;

          // 兼容处理：当在当前页面时直接滚动，否则跳转带参
          if (this.$route.path === this.path) {
              EventBus.$emit(this.busMethod, this.elementRef[s]);
          } else {
              this.$router.push(targetPath);
          }

      }
  },mounted() {
        // console.log(this.items)
    }
};
</script>

<style scoped>
/* 悬停时增加底部条 */
.nav-text::after {
  top: 100%;
  /*margin-top: 0.69vw;*/
  content: "";
  position: absolute;
  bottom: -0.16vw;
  left: 50%;
  width: 0;
  height: 0.16vw;
  background-color: #05358c;
  transition: width 0.3s ease-in-out, left 0.3s ease-in-out;
  z-index: 1;
}

/* 当鼠标悬停时，展开底部条 */
.nav-text:hover::after,
/* 添加激活状态下的样式 */
.nav-text.active::after {
  width: 100%;
  left: 0;
}

/* 子菜单项悬停样式 */
.sub-menu-item:hover {
  background-color: #f0f0f0;
  color: #05358c;
}

/* 进入动画：从下往上 */
.slide-up-enter-active {
  transition: all 0.3s ease-out;
}

/* 进入动画：初始位置 */
.slide-up-enter-from {
  opacity: 0;
  transform: translateX(-50%) translateY(1.56vw);
}

/* 进入动画：最终位置 */
.slide-up-enter-to {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

/* 退出动画：渐隐消失 */
.slide-up-leave-active {
  transition: all 0.3s ease-in;
}

/* 退出动画：初始位置 */
.slide-up-leave-from {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

/* 退出动画：目标位置 */
.slide-up-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(1.04vw);
}



.menu-container {
    @apply relative flex items-center;
}

/* 下拉菜单样式 */
.dropdown-menu {
    @apply absolute left-1/2 transform -translate-x-1/2 mt-[0.5vw] opacity-0 transition-all duration-300;
}

/* 鼠标悬停时显示菜单 */
.menu-container:hover .dropdown-menu {
    @apply opacity-100 translate-y-0;
}


</style>
